import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from '../../services/router-utils';
import { ArrowDownIcon } from '../../components/icons';
import { VerticalSeparator } from '../../components/separator';
import { getCategoryBySlug, getCategories } from '../../selectors/categories-selectors';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import styles from './categories-link.scss';

const CategoriesLink = ({
  categories,
  currentCategory,
  onChange,
  cardBackgroundColor,
}) => {
  const className = classNames(
    styles.container,
    'default-forum-card-background-color',
    'forum-text-color',
    'categories-button'
  );
  return (
    <div className={className} style={{ backgroundColor: cardBackgroundColor }}>
      <VerticalSeparator/>
      <div className={styles.selectContainer}>
        <span>
          {currentCategory && currentCategory.label}
        </span>
        <span>
          <ArrowDownIcon className="forum-icon-fill"/>
        </span>
        <select
          className={styles.select}
          onChange={e => onChange(e.target.value)}
          defaultValue={currentCategory && currentCategory.slug}
        >
          {categories.map(category =>
            <option key={category._id} value={category.slug}>
              {category.label}
            </option>
          )}
        </select>
      </div>
    </div>
  );
};

CategoriesLink.propTypes = {
  categories: PropTypes.array,
  currentCategory: PropTypes.object,
  cardBackgroundColor: PropTypes.string,
  onChange: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  categories: getCategories(state),
  currentCategory: getCategoryBySlug(state, ownProps.params.categorySlug),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    onChange: slug => push(`/${slug}`),
  }, dispatch);

export default flowRight(
  connect(mapStateToProps, mapDispatchToProps),
  withCardBackgroundColor,
)(CategoriesLink);



// WEBPACK FOOTER //
// ./app/containers/categories-link/categories-link.js